"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OKXCosmosProvider = void 0;
const core_1 = require("@okxconnect/core");
class OKXCosmosProvider {
    constructor(provider) {
        this.provider = provider;
    }
    getAccount(chainId) {
        var _a, _b, _c, _d, _e, _f;
        (0, core_1.logDebug)("OKXCosmosProvider getAccount chainId:", chainId);
        (0, core_1.logDebug)("OKXCosmosProvider getAccount namespaces:", JSON.stringify((_a = this.provider.session) === null || _a === void 0 ? void 0 : _a.namespaces));
        let account = (_c = (_b = this.provider.session) === null || _b === void 0 ? void 0 : _b.namespaces[core_1.NameSpaceKeyCosmos]) === null || _c === void 0 ? void 0 : _c.accounts.filter(function (account) {
            return account.startsWith(chainId);
        })[0];
        (0, core_1.logDebug)("OKXCosmosProvider getAccount account:", JSON.stringify(account));
        if (!account) {
            // if (required) {
            //      throw new Error('Account not found')
            // }
            return undefined;
        }
        const accountArray = account.split(':');
        const address = account.split(':')[2];
        (0, core_1.logDebug)("OKXCosmosProvider getAccount address:", address);
        let extra = (_f = (_e = (_d = this.provider.session) === null || _d === void 0 ? void 0 : _d.namespaces[core_1.NameSpaceKeyCosmos]) === null || _e === void 0 ? void 0 : _e.extra) === null || _f === void 0 ? void 0 : _f[(`${accountArray[0]}:${accountArray[1]}`)];
        let publicKey = "";
        if (extra != undefined) {
            publicKey = extra["publicKey"];
            console.log("aptos_publicKey", publicKey);
        }
        if (!address) {
            // if (required) {
            //     throw new Error('Address not found')
            // }
            return undefined;
        }
        return {
            algo: "secp256k1",
            address: address,
            bech32Address: address,
            pubKey: this.hexToUint8Array(publicKey),
        };
    }
    signArbitrary(chainId, signerAddress, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const base64Encoded = window.btoa(data);
            const signDoc = {
                chain_id: "",
                account_number: "0",
                sequence: "0",
                fee: {
                    gas: "0",
                    amount: []
                },
                msgs: [{
                        "type": "sign/MsgSignData",
                        "value": {
                            "signer": signerAddress,
                            "data": base64Encoded
                        }
                    }],
                memo: ""
            };
            let signData = {
                "chainId": chainId,
                "method": "cosmos_signArbitrary",
                "params": {
                    "signer": signerAddress,
                    "chain_id": chainId.split(":")[1],
                    "data": signDoc
                }
            };
            try {
                const ret = yield this.provider.request(signData, chainId);
                if ('result' in ret) {
                    if (typeof ret.result == "string") {
                        return JSON.parse(ret.result);
                    }
                    else {
                        return ret.result;
                    }
                }
                else {
                    let errorData = ret;
                    return errorData.error;
                }
            }
            catch (error) {
                return error;
                // throw new OKXConnectError(OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `the method signTransaction request error`);
            }
        });
    }
    signAmino(chainId, signerAddress, signDoc, signOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            if (signDoc.msgs[0].type == "sign/MsgSignData") {
                let signData = {
                    "chainId": chainId,
                    "method": "cosmos_signArbitrary",
                    "params": {
                        "signer": signerAddress,
                        "chain_id": chainId.split(":")[1],
                        "data": signDoc
                    }
                };
                try {
                    const ret = yield this.provider.request(signData, chainId);
                    if ('result' in ret) {
                        return ret.result;
                    }
                    else {
                        let errorData = ret;
                        return errorData.error;
                    }
                }
                catch (error) {
                    return error;
                    // throw new OKXConnectError(OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `the method signAmino request error`);
                }
            }
            else {
                let signData = {
                    "chainId": chainId,
                    "method": "cosmos_signAmino",
                    "params": {
                        "signer": signerAddress,
                        "chainId": chainId.split(":")[1],
                        "sign_doc": signDoc,
                        "signOptions": signOptions
                    }
                };
                try {
                    const ret = yield this.provider.request(signData, chainId);
                    if ('result' in ret) {
                        const resData = JSON.parse(ret.result);
                        console.log("signdoc", signDoc, resData.signDoc);
                        signDoc.fee = resData.signDoc.fee;
                        return { signed: signDoc, signature: resData.signature };
                    }
                    else {
                        let errorData = ret;
                        return errorData.error;
                    }
                }
                catch (error) {
                    // throw new OKXConnectError(OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `the method signAmino request error`);
                    return error;
                }
            }
        });
    }
    signDirect(chainId, signerAddress, signDoc, signOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const object = {
                bodyBytes: this.bufferToHex(signDoc.bodyBytes),
                authInfoBytes: this.bufferToHex(signDoc.authInfoBytes),
                chainId: signDoc.chainId,
                accountNumber: signDoc.accountNumber ? signDoc.accountNumber.toString() : null,
                signOptions: signOptions ? signOptions : null
            };
            let data = {
                "chainId": chainId,
                "method": "cosmos_signDirect",
                "params": {
                    "signer": signerAddress,
                    "chainId": chainId.split(":")[1],
                    "sign_doc": object,
                }
            };
            try {
                const ret = yield this.provider.request(data, chainId);
                if ('result' in ret) {
                    const res = JSON.parse(ret.result);
                    console.log("signdirect result", res);
                    signDoc.authInfoBytes = this.messageToBuffer(res.signDoc.authInfoBytes);
                    return { signed: signDoc, signature: res.signature };
                }
            }
            catch (error) {
                return error;
                // throw new OKXConnectError(OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `the method signTransaction request error`);
            }
        });
    }
    messageToBuffer(message) {
        var buffer = Uint8Array.from([]);
        try {
            if (typeof message === "string") {
                buffer = this.hexToUint8Array(message.replace("0x", ""));
            }
            else {
                buffer = Uint8Array.from(message);
            }
        }
        catch (err) {
            console.log(`messageToBuffer error: ${err}`);
        }
        return buffer;
    }
    bufferToHex(arr) {
        let output = [...new Uint8Array(arr)]
            .map(x => x.toString(16).padStart(2, '0'))
            .join('');
        return '0x' + output;
    }
    hexToUint8Array(hexString) {
        if (hexString.length % 2 !== 0) {
            throw "Invalid hexString";
        }
        var arrayBuffer = new Uint8Array(hexString.length / 2);
        for (var i = 0; i < hexString.length; i += 2) {
            var byteValue = parseInt(hexString.substr(i, 2), 16);
            if (isNaN(byteValue)) {
                throw "Invalid hexString";
            }
            arrayBuffer[i / 2] = byteValue;
        }
        return arrayBuffer;
    }
}
exports.OKXCosmosProvider = OKXCosmosProvider;
